/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Challenge_Not_Yet_Started_DescriptionInputs */

const en_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something exciting is on the way. Stay tuned!`)
};

const ar_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شيء مشوّق في الطريق. ترقّب!`)
};

const de_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas Spannendes erwartet dich. Bleib dran!`)
};

const es_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se acerca algo emocionante. ¡Mantente al tanto!`)
};

const fr_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une belle surprise arrive bientôt. Restez à l’écoute !`)
};

const it_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è qualcosa di entusiasmante in arrivo. Resta sintonizzato!`)
};

const ja_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワクワクする何かがもうすぐやってきます。お楽しみに！`)
};

const ko_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신나는 무언가가 곧 찾아옵니다. 기대해 주세요!`)
};

const pt_br_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo empolgante está chegando. Fique de olho!`)
};

const ru_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Впереди нечто интересное. Следите за новостями!`)
};

const th_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่น่าตื่นเต้นกำลังจะมา โปรดติดตาม!`)
};

const tr_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heyecan verici bir şey yolda. Takipte kal!`)
};

const zh_cn_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精彩内容即将登场，敬请期待！`)
};

const zh_tw_challenge_not_yet_started_description = /** @type {(inputs: Challenge_Not_Yet_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精彩內容即將登場，敬請期待！`)
};

/**
* | output |
* | --- |
* | "Something exciting is on the way. Stay tuned!" |
*
* @param {Challenge_Not_Yet_Started_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const challenge_not_yet_started_description = /** @type {((inputs?: Challenge_Not_Yet_Started_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Challenge_Not_Yet_Started_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_challenge_not_yet_started_description(inputs)
	if (locale === "ar") return ar_challenge_not_yet_started_description(inputs)
	if (locale === "de") return de_challenge_not_yet_started_description(inputs)
	if (locale === "es") return es_challenge_not_yet_started_description(inputs)
	if (locale === "fr") return fr_challenge_not_yet_started_description(inputs)
	if (locale === "it") return it_challenge_not_yet_started_description(inputs)
	if (locale === "ja") return ja_challenge_not_yet_started_description(inputs)
	if (locale === "ko") return ko_challenge_not_yet_started_description(inputs)
	if (locale === "pt_br") return pt_br_challenge_not_yet_started_description(inputs)
	if (locale === "ru") return ru_challenge_not_yet_started_description(inputs)
	if (locale === "th") return th_challenge_not_yet_started_description(inputs)
	if (locale === "tr") return tr_challenge_not_yet_started_description(inputs)
	if (locale === "zh_cn") return zh_cn_challenge_not_yet_started_description(inputs)
	return zh_tw_challenge_not_yet_started_description(inputs)
});